"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CommentOutline_exports = {};
__export(CommentOutline_exports, {
  default: () => CommentOutline_default
});
module.exports = __toCommonJS(CommentOutline_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.543 15.25L17.375 17.3789C17.5182 17.4701 17.6549 17.4766 17.7852 17.3984C17.9284 17.3073 18 17.1836 18 17.0273V4.41016C18 3.95443 17.8372 3.5638 17.5117 3.23828C17.1862 2.91276 16.7956 2.75 16.3398 2.75H4.66016C4.20443 2.75 3.8138 2.91276 3.48828 3.23828C3.16276 3.5638 3 3.95443 3 4.41016V13.5898C3 14.0456 3.16276 14.4362 3.48828 14.7617C3.8138 15.0872 4.20443 15.25 4.66016 15.25H14.543ZM17.0039 15.8555L14.875 14.2539H4.66016C4.47786 14.2539 4.32161 14.1888 4.19141 14.0586C4.0612 13.9284 3.99609 13.7721 3.99609 13.5898V4.41016C3.99609 4.22786 4.0612 4.07161 4.19141 3.94141C4.32161 3.8112 4.47786 3.74609 4.66016 3.74609H16.3398C16.5221 3.74609 16.6784 3.8112 16.8086 3.94141C16.9388 4.07161 17.0039 4.22786 17.0039 4.41016V15.8555Z",
      fill: "currentColor"
    }
  )
);
const SvgCommentOutline = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var CommentOutline_default = SvgCommentOutline;
